import React, { useState } from 'react';
import Head from 'next/head';

import Layout from '../../components/layout';
import Title from '../../components/title';
import YTGalleryPage from '../../components/yt-gallery-page';
import { fetchVideos } from '@api-service/content';

const Videos = ({ videos, videoListId }) => {
  const [videoId, setVideoId] = useState(undefined);
  const setVideo = (id) => {
    const element = document.querySelector('#yt-video');

    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'nearest'
    });
    setVideoId(id);
  };

  const title = 'Youtube videos';

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>

      <Title>{title}</Title>

      <Layout>
        <div className="article">
          <div className="relative bg-white pt-8 pb-10 px-4 sm:px-6 lg:pb-10 lg:px-8">
            <div className="relative max-w-7xl mx-auto">
              <YTGalleryPage
                pageTitle={title}
                videoId={videoId}
                videoListId={videoListId}
                videos={videos}
                setVideo={(id) => setVideo(id)}
              />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

const REVALIDATE_SECONDS = 600;

export const getStaticProps = async () => {
  const videoListId = 'UUcqEr3DfrRwtoF2a1yW8qgQ';

  try {
    const videos = await fetchVideos();

    return {
      props: {
        videos,
        videoListId
      },
      revalidate: REVALIDATE_SECONDS
    };
  } catch (error) {
    console.error('Failed to fetch videos from ffh-backend:', error);

    // Degrade to an empty gallery rather than failing the build when the
    // backend is unreachable (e.g. preview/test builds); ISR will refill.
    return {
      props: {
        videos: [],
        videoListId
      },
      revalidate: REVALIDATE_SECONDS
    };
  }
};

export default Videos;
